<script>
    import {fade} from 'svelte/transition';
    import { navigateTo } from 'svelte-router-spa';
    import {PRConnect} from "@projectroom/ui-lib";
	import { _ } from 'svelte-i18n';
	import { Card, Button } from '../lib/ui';

    export let currentRoute;

    let email ="";
    let password ="";
    let emailRef,passwordRef;
    let refAgreement, refNotiAgreement;
    let emailBorder = false;
    let passwordBorder = false;
    let errorMesage = "";
    let state = currentRoute.queryParams.state;

    // shadcn 인풋/소셜 버튼 공용 클래스
    const inputCls = "tw-flex tw-h-11 tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-text-foreground placeholder:tw-text-muted-foreground focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring disabled:tw-opacity-50";
    const snsBase = "tw-flex tw-h-11 tw-w-full tw-items-center tw-justify-center tw-gap-2.5 tw-rounded-md tw-text-sm tw-font-semibold tw-transition-opacity tw-cursor-pointer hover:tw-opacity-90";
    const googleBtn = snsBase + " tw-border tw-border-[#dadce0] tw-bg-white tw-text-[#3c4043]";
    const kakaoBtn = snsBase + " tw-bg-[#FEE500] tw-text-[#191600]";
    const errStyle = "border-color:hsl(var(--sb-destructive))";

    const createUser = () => {
        if (validEmail()) {
            emailRef.focus();
            errorMesage = $_('project.default.69_Join');
            return;
        }
        if (validPassword()) {
            passwordRef.focus();
            errorMesage = $_('project.default.70');
            return;
        }
        if (!refAgreement.checked) {
            errorMesage = $_('project.default.71');
            return;
        }
		const notiFlag = refNotiAgreement.checked ? "Y" : "N";
        PRConnect.send("/api/Auth/createUser", {emailId:email, password, state, notiFlag}, data => {
            if (data.result.status === "error") {
                errorMesage = data.result.message;
            } else {
                navigateTo(`${data.result.targetUrl}?${data.result.authToken}`);
            }
        });
    }
    const validPassword = () => {
        //특수문자 / 문자 / 숫자 포함 형태의 8자 이상
        const regex = /^.*(?=^.{8,}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[~`()!@#$%^&+=]).*$/;
        return password.match(regex) == null;
    }
    const validEmail = () => {
        const regex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
        return email.match(regex) == null;
    }

    const changePassword = () => {
        errorMesage = false;
        passwordBorder = validPassword();
    }

    const changeEmail = () => {
        errorMesage = false;
        emailBorder = validEmail();
    }

    const doSNSLogin = (provider) => {
		const userAgent = navigator.userAgent;
		if (userAgent.includes("KAKAO") || userAgent.includes("Instagram")) {
			alert($_('project.default.72'));
			return;
		}
		const statePharase = state ? `&state=${state}` : "";
        switch(provider) {
            case "google":
				const url = `https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${location.origin}/auth/callback/google&prompt=consent&response_type=code${statePharase}&client_id=478826573645-0ahmehhpvmq053jh27c4p646bgak3b8s.apps.googleusercontent.com&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile`;
				location.href = url;
				break;
			case "kakao":
				location.href =
				`https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=dc3054523b05087d5f4582c876e1d3b9${statePharase}&redirect_uri=${location.origin}/auth/callback/kakao`;
				break;
			case "dosi":
				let redirectUri = `${location.origin}/auth/callback/dosi`;
				redirectUri = encodeURIComponent(redirectUri);
				location.href =
				`https://members.dosi.world/?mode=oauth&client_id=MDXUb_U9CRBdUA0j2S3e&redirect_uri=${redirectUri}`;
				break;
        }
    }

</script>

<div class="tw-flex tw-min-h-screen tw-justify-center tw-bg-background tw-px-4 tw-pb-20 tw-pt-24 tw-font-sans tw-text-foreground sm:tw-pt-28" in:fade>
    <div class="tw-w-full tw-max-w-[420px]">
        <Card class="tw-p-8 sm:tw-p-10">
            <h1 class="tw-mb-1 tw-text-center tw-text-2xl tw-font-bold tw-text-foreground">{$_('project.default.73')}</h1>

            {#if errorMesage}
                <div class="tw-mt-4 tw-rounded-md tw-bg-destructive/10 tw-px-3 tw-py-2 tw-text-center tw-text-sm tw-font-medium tw-text-destructive">{errorMesage}</div>
            {/if}

            <form class="tw-mt-6 tw-space-y-4" on:submit|preventDefault={createUser}>
                <div>
                    <label for="join-email" class="tw-mb-1.5 tw-block tw-text-sm tw-font-medium tw-text-foreground">{$_('project.default.74')}</label>
                    <input id="join-email" type="email" maxlength="256" placeholder={$_('project.default.75')} bind:value={email} bind:this={emailRef} on:change={changeEmail} class={inputCls} style={emailBorder ? errStyle : ""} />
                </div>
                <div>
                    <label for="join-pw" class="tw-mb-1.5 tw-block tw-text-sm tw-font-medium tw-text-foreground">{$_('project.default.76')}</label>
                    <input id="join-pw" type="password" maxlength="256" placeholder={$_('project.default.77')} bind:value={password} bind:this={passwordRef} on:change={changePassword} class={inputCls} style={passwordBorder ? errStyle : ""} />
                </div>

                <div class="tw-space-y-2 tw-pt-1">
                    <label class="tw-flex tw-cursor-pointer tw-items-start tw-gap-2.5">
                        <input type="checkbox" bind:this={refAgreement} required class="tw-mt-0.5 tw-h-4 tw-w-4 tw-shrink-0 tw-cursor-pointer tw-accent-primary" />
                        <span class="tw-text-xs tw-leading-relaxed tw-text-muted-foreground">
                            <a class="tw-font-medium tw-text-foreground tw-underline tw-underline-offset-2" href={$_('project.index.50_1')} target="_blank">{$_('project.default.78')}</a>{$_('project.default.79')}<a class="tw-font-medium tw-text-foreground tw-underline tw-underline-offset-2" href={$_('project.index.49_1')} target="_blank">{$_('project.default.80')}</a>{$_('project.default.81')}
                        </span>
                    </label>
                    <label class="tw-flex tw-cursor-pointer tw-items-start tw-gap-2.5">
                        <input type="checkbox" bind:this={refNotiAgreement} class="tw-mt-0.5 tw-h-4 tw-w-4 tw-shrink-0 tw-cursor-pointer tw-accent-primary" />
                        <span class="tw-text-xs tw-leading-relaxed tw-text-muted-foreground">
                            <a class="tw-font-medium tw-text-foreground tw-underline tw-underline-offset-2" href={$_('project.index.51_1')} target="_blank">{$_('project.default.82')}</a>{$_('project.default.83')}
                        </span>
                    </label>
                </div>

                <Button type="submit" size="lg" class="tw-w-full">{$_('project.default.84')}</Button>
            </form>

            <div class="tw-my-6 tw-flex tw-items-center tw-gap-3">
                <div class="tw-h-px tw-flex-1 tw-bg-border"></div>
                <span class="tw-text-xs tw-font-medium tw-uppercase tw-tracking-wider tw-text-muted-foreground">Or</span>
                <div class="tw-h-px tw-flex-1 tw-bg-border"></div>
            </div>

            <div class="tw-space-y-2.5">
                <button type="button" class={googleBtn} on:click={()=> doSNSLogin("google")}>
                    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
                    {$_('project.default.85')}
                </button>
                <button type="button" class={kakaoBtn} on:click={()=> doSNSLogin("kakao")}>
                    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" fill="#191600"><path d="M12 3C6.48 3 2 6.58 2 11c0 2.84 1.9 5.33 4.75 6.74-.2.72-.72 2.62-.83 3.03-.13.51.19.5.4.36.16-.11 2.6-1.77 3.66-2.49.66.1 1.34.15 2.02.15 5.52 0 10-3.58 10-8S17.52 3 12 3z"/></svg>
                    {$_('project.default.86')}
                </button>
            </div>

            <p class="tw-mt-6 tw-text-center tw-text-sm tw-text-muted-foreground">
                {$_('project.default.87')}
                <button type="button" class="tw-cursor-pointer tw-bg-transparent tw-font-semibold tw-text-primary hover:tw-underline" on:click={()=>navigateTo("/login")}>{$_('project.default.88')}</button>
            </p>
        </Card>
    </div>
</div>
